import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { getsingleprescription, getsinglebuildsheetData } from "../../Api/iron"
import { getPrescription } from "../../Api/prescriptionApis"
import TabFormData from "../DashboardComponents/TabsData/TabFormData";
import TabNotesData from "../DashboardComponents/TabsData/TabNotesData";
import { FaAngleUp, FaStar } from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import BuildSheetLeft from "./BuildSheetLeft";
import { getInventoryByType } from "../../Api/inventoryApi";
import { useLocation } from 'react-router-dom';
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";

import { addorderdata, updateOrder, deletedorder } from "../../Api/inventoryApi";

const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    fitter_name: "",
};

const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',
    optimalHeads: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalShafts: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalGrips: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    }
};


const initialPrescriptionStateNew = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',

    bounceselect: '',
    lieageselect: '',
    shaftweightselect: '',
    shaftflexselect: '',
    shaftprofileselect: '',
    gripSizeselect: '',
    clubLengthselect: '',
    swingWeightselect: '',
};


function BuildTabBuildsheet({ project_id, project_step = "history", currentpagename, buildsheets, ondeleteChange, allmodels, StagingStations, remortFittingFormData, nonEmptyStagingStation, allMakeData, prescriptioncalc, buildsheetnumber, orderData, additemstatus }) {

    const [formData, setFormData] = useState(initData);
    const [prescription, setPrescription] = useState(0);
    const [buildsheetData, setBuildsheetData] = useState(0);

    const [current_project_step, setCurrent_project_step] = useState(project_step);
    const [prescriptiondata, setPrescriptiondata] = useState(initialPrescriptionState);

    const [prescriptionNew, setPrescriptionNew] = useState(initialPrescriptionStateNew);


    const [optimalHeads, setOptimalHeads] = useState(0);
    const [optimalShafts, setOptimalShafts] = useState(0);
    const [optimalGrips, setOptimalGrips] = useState(0);

    const [makedata, setMakeData] = useState([]);
    const [shaftdata, setShaftData] = useState([]);
    const [gripdata, setGripData] = useState([]);


    const [head1, setHead1] = useState('');
    const [head2, setHead2] = useState('');
    const [head3, setHead3] = useState('');

    const [Shaft1, setShaft1] = useState('');
    const [Shaft2, setShaft2] = useState('');
    const [Shaft3, setShaft3] = useState('');

    const [Grip1, setGrip1] = useState('');
    const [Grip2, setGrip2] = useState('');
    const [Grip3, setGrip3] = useState('');

    const [allmodelsdata, setAllmodelsdata] = useState([]);


    useEffect(() => {
        if (allmodels && allmodels.length > 0 && allmodelsdata && allmodelsdata.length === 0) {
            setAllmodelsdata(allmodels);
        }
    }, [allmodels]);

    const getDataById = () => {
        setFormData(remortFittingFormData);
        setPrescriptionNew(remortFittingFormData?.fittingdata)
        // manageResult(remortFittingFormData.remotefittingdata);
    }




    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        const filtermakedata = allMakeData && allMakeData.filter((item) => item.item_type_id.includes(id));
        if (id === 4) {
            setMakeData(filtermakedata);
        }
        if (id === 7) {
            setShaftData(filtermakedata);
        }
        if (id === 8) {
            setGripData(filtermakedata);
        }
    }

    const getbuildsheetscript = () => {
        if (prescriptioncalc) {
            setPrescriptiondata(prescriptioncalc);
            setOptimalHeads(parseInt(prescriptioncalc.optimalHeadsStar));
            setOptimalShafts(parseInt(prescriptioncalc.optimalShaftsStar));
            setOptimalGrips(parseInt(prescriptioncalc.optimalGripsStar));
            // setbrandsData(prescriptioncalc);
        }
    }

    const getData = () => {

        switch (current_project_step) {
            case "history":
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
            case "prescription":
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
            case "buildsheet":
                getbuildsheetscript();
                getmakedata(0);
                getDataById();
                break;
            case "stagestation":
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
            case "buildstation":
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
            case "shipstation":
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
            default:
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
        }
    }

    const getprescriptionDataById = () => {
        getsingleprescription({ project_id: project_id }).then((res) => {
            if (res?.code === 200) {
                const prescriptionData = res.data.data;
                setPrescription(prescriptionData);
            } else {
                // alert(res.data?.message);
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }


    useEffect(() => {
        getData();
    }, [project_id, allMakeData, prescriptioncalc])


    const [isTabVisible, setIsTabVisible] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 991) {
                setIsTabVisible(true);
            } else {
                setIsTabVisible(false);
            }
        };

        // Set the initial state
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleNestedChange = (section, option, subField, value) => {

        if (allmodelsdata.length > 0) {
            console.log("allmodelsdata", allmodelsdata);
            const optionKey = `option${option}`;
            let type_id = "";
            switch (section) {
                case "optimalHeads":
                    type_id = "4";
                    break;
                case "optimalShafts":
                    type_id = "7";
                    break;
                case "optimalGrips":
                    type_id = "8";
                    break;
                default:
                    break;
            }

            // Filter the models from allmodels array
            const filteredModels = allmodelsdata.filter(model =>
                model.Make === value && model.type_id === type_id
            );


            // Set the data based on section, subField, and option
            if (filteredModels.length > 0) {
                const data = filteredModels;

                if (section === 'optimalHeads') {
                    switch (option) {
                        case 1:
                            console.log('head 1', data);
                            setHead1(data);
                            break;
                        case 2:
                            setHead2(data);
                            break;
                        case 3:
                            setHead3(data);
                            break;
                        default:
                            break;
                    }
                }

                if (section === 'optimalShafts') {
                    switch (option) {
                        case 1:
                            setShaft1(data);
                            break;
                        case 2:
                            setShaft2(data);
                            break;
                        case 3:
                            setShaft3(data);
                            break;
                        default:
                            break;
                    }
                }

                if (section === 'optimalGrips') {
                    switch (option) {
                        case 1:
                            setGrip1(data);
                            break;
                        case 2:
                            setGrip2(data);
                            break;
                        case 3:
                            setGrip3(data);
                            break;
                        default:
                            break;
                    }
                }

                const updateData = (setFunction, currentData) => {
                    setFunction(prevData => ({
                        ...prevData,
                        [optionKey]: { // Update the correct option (option1, option2, option3)
                            ...prevData[optionKey],
                            [subField]: value // Update the specific field (make or model)
                        }
                    }));
                };

                // Update the correct section (optimalHeads, optimalShafts, or optimalGrips)
                if (section === 'optimalHeads') {
                    updateData(setOptimalHeadsobject, optimalHeadsobject);
                } else if (section === 'optimalShafts') {
                    updateData(setOptimalShaftsobject, optimalShaftsobject);
                } else if (section === 'optimalGrips') {
                    updateData(setOptimalGripsobject, optimalGripsobject);
                }
            } else {
                console.log("");
            }
        }
    };


    useEffect(() => {
        if (allmodelsdata.length > 0) {
            handleNestedChange('optimalHeads', 1, 'make', remortFittingFormData?.optimalHeads?.option1?.make);
            handleNestedChange('optimalHeads', 2, 'make', remortFittingFormData?.optimalHeads?.option2?.make);
            handleNestedChange('optimalHeads', 3, 'make', remortFittingFormData?.optimalHeads?.option3?.make);

            handleNestedChange('optimalShafts', 1, 'make', remortFittingFormData?.optimalShafts?.option1?.make);
            handleNestedChange('optimalShafts', 2, 'make', remortFittingFormData?.optimalShafts?.option2?.make);
            handleNestedChange('optimalShafts', 3, 'make', remortFittingFormData?.optimalShafts?.option3?.make);

            handleNestedChange('optimalGrips', 1, 'make', remortFittingFormData?.optimalGrips?.option1?.make);
            handleNestedChange('optimalGrips', 2, 'make', remortFittingFormData?.optimalGrips?.option2?.make);
            handleNestedChange('optimalGrips', 3, 'make', remortFittingFormData?.optimalGrips?.option3?.make);
        }

    }, [allmodelsdata]);



    const getselectbounce = (category, value) => {
        const selectedValue = parseInt(value);

        // Define options for each category
        const options = {
            bounce: {
                1: 'Low Bounce',
                2: 'Mid Bounce',
                3: 'High Bounce'
            },
            lieAngle: {
                1: 'Upright',
                2: 'Standard',
                3: 'Flat'
            },
            shaftWeight: {
                1: 'Heavy',
                2: 'Medium',
                3: 'Light'
            },
            shaftFlex: {
                1: 'Hard',
                2: 'Medium',
                3: 'Soft'
            },
            shaftProfile: {
                1: 'Firm Tip',
                2: 'Soft Mid',
                3: 'Firm Butt'
            },
            gripSize: {
                1: 'Oversize',
                2: 'Mid',
                3: 'Standard'
            },
            clubLength: {
                1: 'Long',
                2: 'Medium',
                3: 'Short'
            },
            swingWeight: {
                1: 'Heavy',
                2: 'Medium',
                3: 'Light'
            }
        };

        // Return the option label based on category and selected value
        return options[category]?.[selectedValue] || `Select ${category.replace(/([A-Z])/g, ' $1').trim()}`;
    };

    useEffect(() => {
        if (allMakeData.length > 0) {
            getmakedata(4);
            getmakedata(7);
            getmakedata(8);
        }
    }, [allMakeData]);


    const [optimalHeadsobject, setOptimalHeadsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalShaftsobject, setOptimalShaftsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalGripsobject, setOptimalGripsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });


    useEffect(() => {
        if (remortFittingFormData?.optimalHeads) {
            setOptimalHeadsobject(prevState => ({
                ...prevState, // Preserve any existing data
                ...remortFittingFormData.optimalHeads // Update with new data
            }));

            setOptimalHeads(Number(remortFittingFormData?.optimalHeadsStar));
        }

        if (remortFittingFormData?.optimalShafts) {
            setOptimalShaftsobject(prevState => ({
                ...prevState,
                ...remortFittingFormData.optimalShafts
            }));

            setOptimalShafts(Number(remortFittingFormData?.optimalShaftsStar));
        }

        if (remortFittingFormData?.optimalGrips) {
            setOptimalGripsobject(prevState => ({
                ...prevState,
                ...remortFittingFormData.optimalGrips
            }));
            setOptimalGrips(Number(remortFittingFormData?.optimalGripsStar));
        }

        //also check 
    }, [remortFittingFormData]);


    const [buttonNames, setButtonNames] = useState([
        { id: 1, name: "Club Head" },
        { id: 2, name: "Shaft" },
        { id: 3, name: "Grip" },
        { id: 4, name: "Ferrule" },
        { id: 5, name: "Weights" },
        { id: 6, name: "Counter Balance" },
        { id: 7, name: "Shaft Wrap" },
        { id: 8, name: "Adapter" },
    ]);

    //get url from website url 
    const location = useLocation();
    const pathname = location.pathname;


    const segments = pathname.split('/');
    const targetSegment = segments[2]; // "staging-station"

    const [selectedButtons, setSelectedButtons] = useState([]);

    const [show01, setShow01] = useState(false);

    const handleClose01 = () => setShow01(false);
    const handleShow01 = () => setShow01(true);


    const [forms, setForms] = useState([]);

    useEffect(() => {
        if (orderData) {
            setForms(orderData);
        }
    }, [orderData])

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedForms = [...forms];
        updatedForms[index] = {
            ...updatedForms[index],
            [name]: value,
        };
        setForms(updatedForms);
    };


    // Close the form at the specified index

    const [closeloader, setCloseLoader] = useState({});

    const handleCloseForm = async (index, id) => {
        setCloseLoader((prevState) => ({ ...prevState, [id]: true })); // Start loader for this form

        try {
            // Call your API to delete the form
            const res = await deletedorder({ id, project_id }); // Replace with your actual API function
            if (res.data.status) {
                const updatedForms = [...forms];
                updatedForms.splice(index, 1); // Remove the form from the local state
                setForms(updatedForms);
            } else {
                console.error("Error deleting form:", res.data.message);
            }
        } catch (error) {
            console.error("API error:", error);
        } finally {
            setCloseLoader((prevState) => ({ ...prevState, [id]: false })); // Stop loader for this form
        }
    };


    const handleCheckboxChange = async (index, _id) => {
        const updatedForms = [...forms];
        updatedForms[index] = {
            ...updatedForms[index],
            status: !updatedForms[index]?.isChecked, // Toggle the checkbox status
        };
        setForms(updatedForms);

        try {
            const payload = {
                id: forms[index]._id,
                field: 'status',
                value: updatedForms[index].status,
                project_id
            };
            const res = await updateOrder(payload); // Replace with your API function
            if (res.data.status) {
                console.log("Checkbox status updated successfully", res.data);
            } else {
                console.error("Error updating checkbox:", res.data.message);
            }
        } catch (error) {
            console.error("API error:", error);
        }
    };

    const saveorder = (data) => {
        const newdata = {
            project_id: project_id,
            title: data.name
        }
        addorderdata(newdata)
            .then((res) => {
                if (!res.data.status) {
                    console.log("Error:", res.data.data[0].detail);
                } else {
                    const fetchedData = res.data.data;
                    setForms(fetchedData);
                    handleClose01();
                    setSelectedButtons([]);
                }
            })
            .catch((error) => {
                console.log("Error:", error);
            });
    }

    const handleFocusOut = async (index, fieldName, value) => {
        if (!value) return; // Don't call API if the value is empty

        const payload = {
            id: forms[index]._id, // Assuming each form has a unique ID
            field: fieldName,
            value,
            project_id
        };

        try {
            const res = await updateOrder(payload); // Replace with your API call function
            if (res.data.status) {
                const fetchedData = res.data.data;
                setForms(fetchedData);
            } else {
                console.error(`Error updating field ${fieldName}:`, res.data.message);
            }
        } catch (error) {
            console.error("API error:", error);
        }
    };


    const handleCheckboxChange2 = async (index, event) => {
        const { name, value } = event.target;
        const updatedForms = [...forms];
        updatedForms[index] = {
            ...updatedForms[index],
            [name]: value,
        };
        setForms(updatedForms);

        // API call to update the checkbox status
        try {
            const payload = {
                id: forms[index]._id,
                field: 'quantity',
                value: updatedForms[index].quantity,
                project_id
            };
            const res = await updateOrder(payload); // Replace with your API function
            if (res.data.status) {
                const fetchedData = res.data.data;
                setForms(fetchedData);
            } else {
                console.error("Error updating checkbox:", res.data.message);
            }
        } catch (error) {
            console.error("API error:", error);
        }
    };

    return (

        <>

            <Modal size="lg" show={show01} id="success_tic" centered className="modalfix card-radius popup-modal-dark add_club_modal build_sheet_modal">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">Select Order Sheet Categories</h3>
                            <button type="button" className="btn-close" onClick={handleClose01} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className='modal-select-btn'>
                        <div className='select-btn-list'>


                            {buttonNames.map((item) => (
                                <div className='select-btn-item' key={item.id}>
                                    <button
                                        type="button"
                                        className={`btn btn-primary btn-select ${selectedButtons.includes(item.id) ? 'selected' : ''}`}
                                        onClick={() => {
                                            saveorder(item);
                                            setSelectedButtons((prev) => [...prev, item.id]);
                                        }}
                                    >
                                        {item.name}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {
                remortFittingFormData.firstname != "" ? (<>
                    <div className="tab-container tab-club-fitting">
                        <Tabs
                            defaultActiveKey="buildsheet"
                            id="uncontrolled-tab-example"
                            className="club-fitting-tab new_mobile_tab tab-wrapper"
                        >
                            <Tab eventKey="buildsheet" title="Build">
                                <BuildSheetLeft buildsheetdataa={buildsheets} allmodels={allmodels} StagingStations={StagingStations} nonEmptyStagingStation={nonEmptyStagingStation} buildsheets={buildsheetnumber} remortFittingFormData={remortFittingFormData} />
                            </Tab>

                            {
                                formData?.type === "0" && targetSegment !== "staging-station" && (
                                    <Tab eventKey="script" title="Script">
                                        <div className="buildtab-box tab-box-section mb-4">
                                            <div className="accordion-section">
                                                <Accordion defaultActiveKey="0">
                                                    <Accordion.Item eventKey="0" className="results-accordion">
                                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                            <div className="accordion_card_view" id="lesson_card_1">
                                                                <Accordion.Header>
                                                                    <div className="gab_title">
                                                                        <div className="gab_text text-left">
                                                                            <h5>
                                                                                <span className="color"></span>
                                                                                <div className="d-flex align-items-center gap-1">Bounce: <div className="light-text ms-1">{getselectbounce("bounce", prescriptionNew?.bouncedropdownselect)}</div></div>
                                                                            </h5>
                                                                        </div>
                                                                        <div className="collapsed">
                                                                            <div className="gab_icon ">
                                                                                <FaAngleUp />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Accordion.Header>
                                                            </div>
                                                            <Accordion.Body className="results-accordion-body">
                                                                <textarea className="dashboard-text-area" style={{ color: '#ffffff', pointerEvents: 'none' }} value={prescriptionNew?.bounce}  rows="3" placeholder="Enter your script here"></textarea>
                                                            </Accordion.Body>
                                                        </div>
                                                    </Accordion.Item>
                                                    <Accordion.Item eventKey="1" className="results-accordion black">
                                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                            <div className="accordion_card_view" id="lesson_card_1">
                                                                <Accordion.Header>
                                                                    <div className="gab_title">
                                                                        <div className="gab_text text-left">
                                                                            <h5>
                                                                                <span className="color"></span>
                                                                                <div className="d-flex align-items-center gap-1">Lie Angle:  <div className="light-text ms-1">{getselectbounce("lieAngle", prescriptionNew?.lieagedropdownselect)}</div></div>
                                                                            </h5>
                                                                        </div>
                                                                        <div className="collapsed">
                                                                            <div className="gab_icon ">
                                                                                <FaAngleUp />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Accordion.Header>
                                                            </div>
                                                            <Accordion.Body className="results-accordion-body">
                                                                <textarea className="dashboard-text-area" value={prescriptionNew?.lieage} style={{ color: '#ffffff', pointerEvents: 'none' }} rows="3" placeholder="Enter your script here"></textarea>
                                                            </Accordion.Body>
                                                        </div>
                                                    </Accordion.Item>
                                                    <Accordion.Item eventKey="2" className="results-accordion blue">
                                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                            <div className="accordion_card_view" id="lesson_card_1">
                                                                <Accordion.Header>
                                                                    <div className="gab_title">
                                                                        <div className="gab_text text-left">
                                                                            <h5>
                                                                                <span className="color"></span>
                                                                                <div className="d-flex align-items-center gap-1">Shaft Weight: <div className="light-text ms-1">{getselectbounce("shaftWeight", prescriptionNew?.shaftweightdropdownselect)}</div></div>
                                                                            </h5>
                                                                        </div>
                                                                        <div className="collapsed">
                                                                            <div className="gab_icon ">
                                                                                <FaAngleUp />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Accordion.Header>
                                                            </div>
                                                            <Accordion.Body className="results-accordion-body">
                                                                <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.shaftweight} style={{ color: '#ffffff', pointerEvents: 'none' }}  placeholder="Enter your script here"></textarea>
                                                            </Accordion.Body>
                                                        </div>
                                                    </Accordion.Item>
                                                    <Accordion.Item eventKey="3" className="results-accordion pink">
                                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                            <div className="accordion_card_view" id="lesson_card_1">
                                                                <Accordion.Header>
                                                                    <div className="gab_title">
                                                                        <div className="gab_text text-left">
                                                                            <h5>
                                                                                <span className="color"></span>
                                                                                <div className="d-flex align-items-center gap-1">Shaft Flex:  <div className="light-text ms-1">{getselectbounce("shaftFlex", prescriptionNew?.shaftflexdropdownselect)}</div></div>
                                                                            </h5>
                                                                        </div>
                                                                        <div className="collapsed">
                                                                            <div className="gab_icon ">
                                                                                <FaAngleUp />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Accordion.Header>
                                                            </div>
                                                            <Accordion.Body className="results-accordion-body">
                                                                <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.shaftflex} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                            </Accordion.Body>
                                                        </div>
                                                    </Accordion.Item>
                                                    <Accordion.Item eventKey="5" className="results-accordion red">
                                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                            <div className="accordion_card_view" id="lesson_card_1">
                                                                <Accordion.Header>
                                                                    <div className="gab_title">
                                                                        <div className="gab_text text-left">
                                                                            <h5>
                                                                                <span className="color"></span>
                                                                                <div className="d-flex align-items-center gap-1">Grip Size:  <div className="light-text ms-1">{getselectbounce("gripSize", prescriptionNew?.gripSizedropdownselect)}</div></div>
                                                                            </h5>
                                                                        </div>
                                                                        <div className="collapsed">
                                                                            <div className="gab_icon ">
                                                                                <FaAngleUp />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Accordion.Header>
                                                            </div>
                                                            <Accordion.Body className="results-accordion-body">
                                                                <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.gripSize} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                            </Accordion.Body>
                                                        </div>
                                                    </Accordion.Item>
                                                    <Accordion.Item eventKey="6" className="results-accordion orange">
                                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                            <div className="accordion_card_view" id="lesson_card_1">
                                                                <Accordion.Header>
                                                                    <div className="gab_title">
                                                                        <div className="gab_text text-left">
                                                                            <h5>
                                                                                <span className="color"></span>
                                                                                <div className="d-flex align-items-center gap-1">Club Length:  <div className="light-text ms-1">{getselectbounce("clubLength", prescriptionNew?.clubLengthdropdownselect)}</div></div>
                                                                            </h5>
                                                                        </div>
                                                                        <div className="collapsed">
                                                                            <div className="gab_icon ">
                                                                                <FaAngleUp />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Accordion.Header>
                                                            </div>
                                                            <Accordion.Body className="results-accordion-body">
                                                                <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.clubLength} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                            </Accordion.Body>
                                                        </div>
                                                    </Accordion.Item>
                                                    <Accordion.Item eventKey="7" className="results-accordion green">
                                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                            <div className="accordion_card_view" id="lesson_card_1">
                                                                <Accordion.Header>
                                                                    <div className="gab_title">
                                                                        <div className="gab_text text-left">
                                                                            <h5>
                                                                                <span className="color"></span>
                                                                                <div className="d-flex align-items-center gap-1">Swing Weight:  <div className="light-text ms-1">{getselectbounce("swingWeight", prescriptionNew?.swingWeightdropdownselect)}</div></div>
                                                                            </h5>
                                                                        </div>
                                                                        <div className="collapsed">
                                                                            <div className="gab_icon ">
                                                                                <FaAngleUp />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Accordion.Header>
                                                            </div>
                                                            <Accordion.Body className="results-accordion-body">
                                                                <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.swingWeight} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                            </Accordion.Body>
                                                        </div>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </div>
                                        </div>
                                        <div className="tab-box-section mb-4">
                                            <div className="">
                                                <div className="club-fitting-card black_box">
                                                </div>
                                                <div className="form-group prescription-note presc-tab2">
                                                    <div className="row mb-3">
                                                        {optimalHeads === 1 && (
                                                            <>
                                                                <div className="row mb-3 align-items-center">
                                                                    <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }}>
                                                                        <svg stroke="currentColor" fill="#aee750" strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                                        </svg>
                                                                    </label>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalHeadsobject?.option1?.make} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                            <option value="" disabled>Make</option>
                                                                            {makedata && makedata.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalHeadsobject?.option1?.model} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                            <option value="" disabled>Model</option>
                                                                            {head1 && head1.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {optimalHeads === 2 && (
                                                            <>
                                                                <div className="row mb-3 align-items-center">
                                                                    <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }}>
                                                                        <svg stroke="currentColor" fill="#aee750" strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                                        </svg>
                                                                    </label>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalHeadsobject?.option2?.make} onChange={(e) => handleNestedChange('optimalHeads', 2, 'make', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                            <option value="" disabled>Make</option>
                                                                            {makedata && makedata.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalHeadsobject?.option2?.model} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                            <option value="" disabled>Model</option>
                                                                            {head2 && head2.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {optimalHeads === 3 && (
                                                            <>
                                                                <div className="row mb-3 align-items-center">
                                                                    <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }}>
                                                                        <svg stroke="currentColor" fill="#aee750" strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                                        </svg>
                                                                    </label>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalHeadsobject?.option3?.make} onChange={(e) => handleNestedChange('optimalHeads', 3, 'make', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                            <option value="" disabled>Make</option>
                                                                            {makedata && makedata.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalHeadsobject?.option3?.model} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                            <option value="" disabled>Model</option>
                                                                            {head3 && head3.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}

                                                        {optimalShafts === 1 && (
                                                            <>
                                                                <div className="row mb-3 align-items-center">
                                                                    <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }} >
                                                                        <svg stroke="currentColor" fill={`${optimalShafts === 1 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                                    </label>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalShaftsobject?.option1?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Make</option>
                                                                            {shaftdata && shaftdata.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalShaftsobject?.option1?.model || ""} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Model</option>
                                                                            {Shaft1 && Shaft1.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}

                                                        {optimalShafts === 2 && (
                                                            <>
                                                                <div className="row mb-3 align-items-center">
                                                                    <label className="col-2 col-sm-2 " style={{ marginTop: '10px', marginRight: '-30px' }} >
                                                                        <svg stroke="currentColor" fill={`${optimalShafts === 2 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                                    </label>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalShaftsobject?.option2?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Make</option>
                                                                            {shaftdata && shaftdata.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalShaftsobject?.option2?.model || ""} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Model</option>
                                                                            {Shaft2 && Shaft2.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}

                                                        {optimalShafts === 3 && (
                                                            <>
                                                                <div className="row mb-3 align-items-center">
                                                                    <label className="col-2 col-sm-2"
                                                                        style={{ marginTop: '10px', marginRight: '-30px' }}
                                                                    ><svg stroke="currentColor" fill={`${optimalShafts === 3 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalShaftsobject?.option3?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Make</option>
                                                                            {shaftdata && shaftdata.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalShaftsobject?.option3?.model || ""} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Model</option>
                                                                            {Shaft3 && Shaft3.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}

                                                        {optimalGrips === 1 && (
                                                            <>
                                                                <div className="row mb-3 align-items-center">
                                                                    <label className="col-2 col-sm-2"
                                                                        style={{ marginTop: '10px', marginRight: '-30px' }}
                                                                    ><svg stroke="currentColor" fill={`${optimalGrips === 1 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalGripsobject?.option1?.make} onChange={(e) => handleNestedChange('optimalGrips', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Make</option>
                                                                            {gripdata && gripdata.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalGripsobject?.option1?.model} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Model</option>
                                                                            {Grip1 && Grip1.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}

                                                        {optimalGrips === 2 && (
                                                            <>
                                                                <div className="row mb-3 align-items-center">
                                                                    <label className="col-2 col-sm-2"
                                                                        style={{ marginTop: '10px', marginRight: '-30px' }}
                                                                    ><svg stroke="currentColor" fill={`${optimalGrips === 2 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalGripsobject?.option2?.make} onChange={(e) => handleNestedChange('optimalGrips', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Make</option>
                                                                            {gripdata && gripdata.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalGripsobject?.option2?.model} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Model</option>
                                                                            {Grip2 && Grip2.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}

                                                        {optimalGrips === 3 && (
                                                            <>
                                                                <div className="row mb-3 align-items-center">
                                                                    <label className="col-2 col-sm-2"
                                                                        style={{ marginTop: '10px', marginRight: '-30px' }}
                                                                    ><svg stroke="currentColor" fill={`${optimalGrips === 3 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalGripsobject?.option3?.make} onChange={(e) => handleNestedChange('optimalGrips', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Make</option>
                                                                            {gripdata && gripdata.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-5 col-sm-5 mb-3">
                                                                        <select disabled value={optimalGripsobject?.option3?.model} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                            <option value="" disabled>Model</option>
                                                                            {Grip3 && Grip3.map((item) => (
                                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                )}

                            <Tab eventKey="client" title="Client">
                                <div className="tab-box-section">
                                    <TabFormData project_id={project_id} remortFittingFormData={remortFittingFormData} />
                                </div>
                            </Tab>

                            {
                                targetSegment == 'staging-station' && (
                                    <Tab eventKey="orders" title="Orders">
                                        {/* {activeKey === "orders" && ( */}
                                        <>
                                            <div className="tab-box-section py-3">
                                                <div className="btn-box-section mt-0 px-0">
                                                    <style>
                                                        {`
                                                            .btn-create.btn-item-add { background-color: rgba(60,68,80,1) !important; color: #fff !important}
                                                        `}
                                                    </style>

                                                    {
                                                        forms.length < 100 ? <button className="btn btn-primary btn-create btn-item-add" disabled={additemstatus !== 'Assigned' && additemstatus !== 'Ordering' && additemstatus !== 'Ready'} style={{ backgroundColor: 'rgba(60,68,80,1) !important' }} onClick={handleShow01}>Add Item</button> : <button className="btn btn-primary btn-create btn-item-add" disabled>Add Item</button>
                                                    }

                                                </div>

                                                {forms.map((form, index) => (
                                                    <>
                                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                                            <div className="d-flex align-items-center">
                                                                <div className='form-group-check me-3'>
                                                                    <input type="checkbox" className="form-check-input" checked={form.status === "true" || form.status === true} style={{ width: '40px', height: '40px' }} onChange={() => handleCheckboxChange(index, form._id)} />
                                                                </div>
                                                                <label className='form-label'>{form.title}</label>
                                                            </div>
                                                            <div className='form-group-check'>
                                                                <div onClick={() => handleCloseForm(index, form._id)} type="checkbox" className="form-check-input d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                                                                    {closeloader[form._id] ? (
                                                                        <div className="spinner-border spinner-border-sm text-light" role="status">
                                                                            <span className="visually-hidden">Loading...</span>
                                                                        </div>
                                                                    ) : (
                                                                        <IoClose size={25} />
                                                                    )}</div>
                                                            </div>

                                                        </div>

                                                        <Form noValidate>
                                                            <div className="row gx-2">
                                                                <div className="col-md-9 form-group" controlid="validationCustom02">
                                                                    <input name="itemName" type="text" required value={form.itemName || ""} onChange={(e) => handleInputChange(index, e)}
                                                                        onBlur={() => handleFocusOut(index, "itemName", form.itemName)} className="form-control dashboard-input-box-3" placeholder="Item Needed...." />
                                                                </div>
                                                                <div className="col-md-3 form-group" controlid="validationCustom01">
                                                                    <select
                                                                        name="quantity"
                                                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                                        value={form.quantity || ""}
                                                                        onChange={(e) => handleCheckboxChange2(index, e)}
                                                                        aria-label="Default select example"
                                                                    >
                                                                        <option value={0}>Qty.</option>
                                                                        {Array.from({ length: 100 }, (_, i) => (
                                                                            <option key={i + 1} value={i + 1}>
                                                                                {i + 1}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-12 form-group" controlid="validationCustom03">
                                                                    <textarea name="itemNotes" title="Item Notes..." className="form-control dashboard-input-box-3" onBlur={() => handleFocusOut(index, "itemNotes", form.itemNotes)} value={form.itemNotes || ""} onChange={(e) => handleInputChange(index, e)} placeholder="Item Notes..." required />
                                                                </div>
                                                            </div>
                                                        </Form>
                                                    </>
                                                ))}
                                            </div>
                                        </>
                                        {/* )} */}
                                    </Tab>
                                )
                            }

                            <Tab eventKey="notes" title="Notes">
                                <TabNotesData project_id={project_id} />
                            </Tab>
                        </Tabs>
                    </div>
                </>) : (<> </>)


            }
        </>
    );
}

export default BuildTabBuildsheet;